import { useQuery } from "@tanstack/react-query";

import apiDal from "../config/apiDal";
import { Airline } from "../types";

const fetchAirlines = async (): Promise<Airline[]> => {
	const response = await apiDal.post("/queries/fetch", {
		query: "getAirlines",
		bind: {},
	});

	return response.data.result;
};

export const useGetAirlines = () => {
	return useQuery<Airline[]>({
		queryKey: ["getAirlines"],
		queryFn: () => fetchAirlines(),
		select: (data) => data,
	});
};
